import React from 'react';
import { FadeIn, CTAButton, Section } from './Shared';
import { useCountdown } from '../hooks/useCountdown';
import { ShieldCheck, Lock, CreditCard, Star, XCircle } from 'lucide-react';
export const UrgencyBar = () => {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  return <div className="bg-bg-card text-txt-primary py-2 md:py-3 px-3 md:px-4 sticky top-0 z-50 shadow-md border-b border-line" data-id="element-287">
      <div className="max-w-4xl mx-auto flex flex-row items-center justify-center gap-1.5 md:gap-6 text-center text-[11px] md:text-base font-medium" data-id="element-288">
        <div className="flex items-center gap-1 md:gap-2" data-id="element-289">
          <span className="animate-pulse hidden md:inline" data-id="element-290">⏰</span>
          <span className="hidden md:inline" data-id="element-291">
            PRECIO DE LANZAMIENTO — CIERRA EN:
          </span>
          <span className="md:hidden" data-id="element-292">LANZAMIENTO —</span>
          <span className="font-bold bg-white/10 px-1.5 md:px-2 py-0.5 md:py-1 rounded text-xs md:text-base" data-id="element-293">
            {hours.toString().padStart(2, '0')}:
            {minutes.toString().padStart(2, '0')}:
            {seconds.toString().padStart(2, '0')}
          </span>
        </div>
        <span className="text-brandOrange font-bold text-[10px] md:text-base" data-id="element-294">
          Sube el precio. No vuelve.
        </span>
      </div>
    </div>;
};
export const Hero = () => {
  return <section className="bg-bg-base px-4 pt-6 pb-8 md:pt-16 md:pb-16 overflow-hidden" data-id="element-295">
      <div className="max-w-[700px] mx-auto text-center space-y-3 md:space-y-6" data-id="element-296">
        <FadeIn data-id="element-297">
          <div className="space-y-2 md:space-y-4" data-id="element-298">
            <div className="inline-flex items-center gap-1.5 bg-bg-card text-brandOrange font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[11px] px-3 py-1 md:px-4 md:py-1.5 rounded-full border border-brandOrange/30 pt-[2px] pb-[2px] pl-[10px] pr-[10px]" data-id="element-299">
              <span className="text-sm md:text-base" data-id="element-300">🏋️</span>
              <span className="text-[8px]" data-id="element-301">MEGAPACK FUNCIONAL 365™</span>
            </div>
            <h1 className="font-display font-black uppercase text-[32px] md:text-[64px] leading-[1.0] tracking-tight text-txt-primary px-2" data-id="element-302">
              Todo tu año de
              <br data-id="element-303" />
              <span className="text-brandOrange" data-id="element-304">funcional.</span>
              <br data-id="element-305" />
              <span data-id="element-306">Listo. Desde hoy.</span>
            </h1>
            <p className="text-txt-body text-[13px] md:text-[16px] leading-[1.5] md:leading-[1.7] font-sans px-3" data-id="element-307">
              365 sesiones · Warm-ups · Circuitos · Clases listas · WODs
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.15} data-id="element-308">
          <a href="#pricing" className="block cursor-pointer relative" data-id="element-309">
            <div className="absolute inset-0 bg-brandOrange/15 blur-[80px] rounded-full" data-id="element-310"></div>
            <div className="absolute inset-y-0 -inset-x-10 bg-brandBlue-electric/10 blur-[60px] rounded-full" data-id="element-311"></div>
            <img src="https://cdn.magicpatterns.com/uploads/vwRcuoDTAfFcum46xyN36c/heylloyd-image-1779124303621.png" alt="MEGAPACK Funcional 365 — Mockup completo del producto" loading="eager" decoding="async"
          // @ts-ignore
          fetchpriority="high" className="relative block w-full max-w-[260px] md:max-w-[480px] mx-auto h-auto object-contain hover:-translate-y-1 transition-transform duration-300 drop-shadow-2xl" data-id="element-312" />
          </a>
        </FadeIn>

        <FadeIn delay={0.25} data-id="element-313">
          <div className="max-w-2xl mx-auto space-y-3 md:space-y-5" data-id="element-314">
            {/* Chips - same on all screens */}
            <div className="flex flex-wrap gap-1.5 md:gap-2 justify-center items-center" data-id="element-315">
              <span className="bg-bg-card text-txt-body px-2.5 py-1 md:px-3 md:py-1.5 rounded-full text-[11px] md:text-sm font-sans border border-line inline-flex items-center gap-1 whitespace-nowrap" data-id="element-316">
                <span className="text-xs" data-id="element-317">📄</span> 100% PDF
              </span>
              <span className="bg-bg-card text-txt-body px-2.5 py-1 md:px-3 md:py-1.5 rounded-full text-[11px] md:text-sm font-sans border border-line inline-flex items-center gap-1 whitespace-nowrap" data-id="element-318">
                <span className="text-xs" data-id="element-319">⚡</span> Acceso en 5 min
              </span>
              <span className="bg-bg-card text-txt-body px-2.5 py-1 md:px-3 md:py-1.5 rounded-full text-[11px] md:text-sm font-sans border border-line inline-flex items-center gap-1 whitespace-nowrap" data-id="element-320">
                <span className="text-xs" data-id="element-321">📚</span> 365 sesiones
              </span>
            </div>

            {/* CTA button + trust */}
            <div className="space-y-2 md:space-y-3" data-id="element-322">
              <CTAButton href="#pricing" fullWidth data-id="element-323">
                💪 QUIERO EL MEGAPACK AHORA
              </CTAButton>

              <div className="flex flex-wrap items-center justify-center gap-2.5 md:gap-4 text-[10px] md:text-xs text-txt-muted font-sans" data-id="element-324">
                <span className="flex items-center gap-1" data-id="element-325">
                  <ShieldCheck size={12} className="text-success" data-id="element-326" /> Garantía 15
                  días
                </span>
                <span className="flex items-center gap-1" data-id="element-327">
                  <Lock size={12} className="text-txt-muted" data-id="element-328" /> Pago seguro
                </span>
                <span className="flex items-center gap-1" data-id="element-329">
                  <CreditCard size={12} className="text-brandBlue-electric" data-id="element-330" />{' '}
                  Mercado Pago
                </span>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
};
export const SocialProof = () => {
  return <div className="bg-bg-alt border-y border-line py-6" data-id="element-331">
      <div className="max-w-[1100px] mx-auto px-6" data-id="element-332">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center divide-x divide-line" data-id="element-333">
          <FadeIn delay={0.1} data-id="element-334">
            <div className="font-display font-black text-[30px] md:text-[44px] leading-[1.1] text-brandOrange mb-0.5" data-id="element-335">
              +800
            </div>
            <div className="text-sm font-sans text-txt-body" data-id="element-336">
              coaches confían
            </div>
          </FadeIn>
          <FadeIn delay={0.2} data-id="element-337">
            <div className="font-display font-black text-[30px] md:text-[44px] leading-[1.1] text-brandOrange mb-0.5" data-id="element-338">
              6
            </div>
            <div className="text-sm font-sans text-txt-body" data-id="element-339">Tomos listos</div>
          </FadeIn>
          <FadeIn delay={0.3} data-id="element-340">
            <div className="font-display font-black text-[30px] md:text-[44px] leading-[1.1] text-brandOrange mb-0.5" data-id="element-341">
              6
            </div>
            <div className="text-sm font-sans text-txt-body" data-id="element-342">
              Bonos incluidos
            </div>
          </FadeIn>
          <FadeIn delay={0.4} data-id="element-343">
            <div className="font-display font-black text-[30px] md:text-[44px] leading-[1.1] text-brandOrange mb-0.5" data-id="element-344">
              4.9/5
            </div>
            <div className="text-sm font-sans text-txt-body flex items-center justify-center gap-1" data-id="element-345">
              calificación <Star size={12} className="fill-gold text-gold" data-id="element-346" />
            </div>
          </FadeIn>
        </div>
      </div>
    </div>;
};
export const Testimonials1 = () => {
  const testimonials = [{
    initials: 'MR',
    text: 'Llegué al lunes con todo listo por primera vez en años. Los warm-ups me salvaron.',
    author: 'Marcos R.',
    role: 'Coach de Funcional · Bs. As.',
    bg: 'bg-brandOrange'
  }, {
    initials: 'CP',
    text: 'Tengo grupos de distintos niveles. El kit de adaptaciones cambió todo.',
    author: 'Carolina P.',
    role: 'Instructora · Córdoba',
    bg: 'bg-brandBlue-electric'
  }, {
    initials: 'DG',
    text: 'En 10 minutos tengo la clase del lunes armada. Mis alumnos notan la diferencia.',
    author: 'Diego G.',
    role: 'Profe de Box · Rosario',
    bg: 'bg-brandOrange'
  }];
  return <Section className="bg-bg-base" data-id="element-347">
      <div className="grid md:grid-cols-3 gap-4 md:gap-5" data-id="element-348">
        {testimonials.map((t, i) => <FadeIn key={i} delay={Math.min(i * 0.05, 0.2)} data-id="element-349">
            <div className="bg-bg-card p-5 md:p-6 rounded-[20px] border border-line h-full flex flex-col" data-id="element-350">
              <div className="flex items-center gap-3 mb-3" data-id="element-351">
                <div className={`w-10 h-10 ${t.bg} text-white rounded-full flex items-center justify-center font-sans font-bold text-sm shrink-0`} data-id="element-352">
                  {t.initials}
                </div>
                <div data-id="element-353">
                  <div className="flex text-gold mb-0.5" data-id="element-354">
                    {[...Array(5)].map((_, j) => <Star key={j} size={11} className="fill-current" data-id="element-355" />)}
                  </div>
                  <p className="font-sans font-bold text-txt-primary text-sm leading-tight" data-id="element-356">
                    {t.author}
                  </p>
                  <p className="text-xs font-sans text-txt-muted" data-id="element-357">{t.role}</p>
                </div>
              </div>
              <p className="text-txt-body font-sans text-sm md:text-base leading-[1.6] italic" data-id="element-358">
                "{t.text}"
              </p>
            </div>
          </FadeIn>)}
      </div>
    </Section>;
};
export const Problem = () => {
  const painPoints = ['Llegás al gym sin saber exactamente qué clase vas a dar hoy', 'Pasás horas del domingo buscando ejercicios en Instagram que nunca quedan bien para tu grupo', 'Siempre los mismos circuitos porque no tenés un banco de sesiones serio', 'El alumno nuevo llega y no sabés cómo adaptarle la clase en el momento', 'Querés un programa anual estructurado pero no tenés tiempo de armarlo', 'Tu grupo se estanca porque no hay progresión real de semana en semana', 'Fin de semana agotado y el domingo a la noche volvés a empezar el mismo ciclo'];
  return <Section className="bg-bg-alt" data-id="element-359">
      <div className="max-w-[720px] mx-auto" data-id="element-360">
        <FadeIn data-id="element-361">
          <h2 className="font-display font-extrabold uppercase text-[26px] md:text-[44px] leading-[1.1] text-center mb-8 text-txt-primary" data-id="element-362">
            Si sos profe de <span className="text-brandOrange" data-id="element-363">funcional,</span>
            <br data-id="element-364" />
            esto te va a sonar familiar
          </h2>

          <div className="space-y-3 md:space-y-4 mb-10" data-id="element-365">
            {painPoints.map((point, i) => <div key={i} className="flex items-start gap-3 bg-bg-card border border-line rounded-[12px] p-[14px] px-[16px]" data-id="element-366">
                <XCircle className="text-danger shrink-0 mt-0.5" size={20} data-id="element-367" />
                <p className="text-txt-body font-sans text-[15px] md:text-base leading-[1.6]" data-id="element-368">
                  {point}
                </p>
              </div>)}
          </div>

          <div className="text-center mb-12" data-id="element-369">
            <p className="font-display font-extrabold text-[26px] md:text-[44px] leading-[1.1] text-txt-primary" data-id="element-370">
              No es falta de vocación.
              <br data-id="element-371" />
              Es falta de un sistema.
            </p>
          </div>

          <h3 className="font-display font-extrabold uppercase text-[26px] md:text-[44px] leading-[1.1] text-center text-txt-primary mb-8" data-id="element-372">
            ¿Cuánto tiempo más vas a{' '}
            <span className="text-brandOrange" data-id="element-373">improvisar?</span>
          </h3>

          <div className="space-y-4 text-txt-body font-sans text-[15px] md:text-base leading-[1.7] mb-12" data-id="element-374">
            <p data-id="element-375">
              Elegiste esta profesión porque amás el entrenamiento funcional y
              ver a tu grupo crecer.
            </p>
            <p data-id="element-376">
              Pero nadie te dijo que ibas a pasar los domingos buscando
              circuitos que no encajan con tu grupo, armando sesiones a último
              momento y llegando el lunes improvisando con lo que más o menos
              sirve.
            </p>
          </div>

          <p className="font-sans font-bold text-lg md:text-xl text-center text-txt-primary leading-snug" data-id="element-377">
            ¿Y si este fuera el último domingo que pasás así?
          </p>
        </FadeIn>
      </div>
    </Section>;
};